<template>
  <div class="dialog-user-edit">
    <Form :model="formData" :label-width="100" ref="editUserForm" :rules="validateRules" v-if="!formLoading"  :readonly="readonly">
      <FormItem label="手机号：" prop="mobile">
        <Input :maxlength= '18' v-model="formData.mobile" placeholder="请输入手机号" @on-blur="handleBlur" :disabled="isShowForm"></Input>
      </FormItem>
      <div v-if="isShowForm">
        <FormItem label="姓名：" prop="name">
          <Input v-model="formData.name" placeholder="请输入姓名" :disabled="isDisabled"></Input>
        </FormItem>
        <FormItem label="证件类型：" prop="idCardType">
          <Select v-model="formData.idCardType" filterable :disabled="isDisabled">
            <Option v-for="option in cardList" :value="option.code" :key="option.code">{{option.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="证件号码：" prop="identityCard">
          <Input v-model="formData.identityCard" placeholder="请输入证件号码" :disabled="isDisabled"></Input>
        </FormItem>
        <FormItem label="单位属性：" prop="type" v-if="accountType!=='6'">
          <Select v-model="formData.type" filterable @on-change="fetchSchoolList(formData.type)">
            <Option value="1">学校</Option>
            <Option value="2">其他</Option>
          </Select>
        </FormItem>
        <FormItem label="单位名称：" prop="schoolId" v-if="accountType!='6'">
          <Select v-model="formData.schoolId" filterable>
            <Option v-for="(option, index) in schoolList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="单位名称：" v-if="accountType=='6'">
          <Row>{{schoolName}}</Row>
        </FormItem>
        <FormItem label="单位代码：" prop="schoolCode" v-if="formData.schoolId=='-1'">
          <Input v-model="formData.schoolCode" placeholder="请输入单位代码" :disabled="isDisabled"></Input>
        </FormItem>
        <FormItem label="单位名称：" prop="schoolName" v-if="formData.schoolId=='-1'">
          <Input v-model="formData.schoolName" placeholder="请输入单位名称" :disabled="isDisabled"></Input>
        </FormItem>
        <FormItem label="所属学院：" prop="department" v-if="formData.type=='1'">
          <Input v-model="formData.department" placeholder="请输入所属学院"></Input>
        </FormItem>
        <!--      <FormItem v-if="formData.pointLevel=='2'" label="所属学院">-->
        <!--        <Input v-model="formData.department" placeholder="请输入所属学院" :disabled="isDisabled"></Input>-->
        <!--      </FormItem>-->
        <!--      <FormItem class="parentContact" v-if="formData.pointLevel=='2'" label="上级联系人" prop="parentContact">-->
        <!--        <Select v-model="formData.parentContact">-->
        <!--          <Option v-for="option in parentList" :key="option.id" :value="option.id">{{option.name}}</Option>-->
        <!--        </Select>-->
        <!--      </FormItem>-->
        <!-- bank -->
        <!-- <FormItem label="开户省份" prop="bankProvince" v-if="!query">
          <Select v-model="formData.bankProvince" :disabled="isDisabled">
            <Option v-for="(option, index) in proList" :value="option.id" :key="index">{{option.mc}}</Option>
          </Select>
        </FormItem>
        <FormItem label="开户银行" prop="bankId" v-if="!query">
          <Select v-model="formData.bankId" :disabled="isDisabled">
            <Option v-for="(option, index) in bankList" :value="option.id" :key="index">{{option.mc}}</Option>
          </Select>
        </FormItem>
        <FormItem label="银行卡号" prop="bankCard" v-if="!query">
          <Input v-model="formData.bankCard" placeholder="请输入银行卡号" :disabled="isDisabled"></Input>
        </FormItem> -->
        <!-- bank end -->
      </div>
    </Form>
    <Spin size="large" fix v-if="formLoading"></Spin>
  </div>
</template>

<script>
/* global FormItemRules:true */
export default {
  props: {
    query: ''
  },
  data () {
    const isPHONE = (rule, value, callback) => {
      if (value) {
        if (!this.formDefaultRules.isPHONE.test(value)) {
          return callback(new Error('输入的手机号不符合规则'));
        }
      }
      return callback();
    };
    return {
      validateRules: {
        name: [{required: true, message: '请填写姓名', trigger: 'blur'}],
        mobile: [{required: true, message: '请填写手机号', trigger: 'blur'}, {validator: isPHONE, trigger: 'blur'}],
        type: [{required: true, message: '请选择单位属性', trigger: 'change'}],
        schoolId: [{required: true, message: '请选择单位名称', trigger: 'change'}],
        // idCardType: [{required: true, message: '请选择证件类型', trigger: 'change'}],
        // identityCard: [{required: true, message: '请填写证件号码', trigger: 'blur'}],
        // department: [{required: true, message: '请填写所属学院', trigger: 'blur'}],
        // contactAddress: [{required: true, message: '请填写联系地址', trigger: 'blur'}],
        // bankProvince: [{required: true, message: '请选择省份', trigger: 'change'}],
        // bankId: [{required: true, message: '请选择银行', trigger: 'change'}],
        // bankCard: [{required: true, message: '请填写银行卡号', trigger: 'blur'}],
        pointLevel: [{required: true, message: '请选择指派级别', trigger: 'change'}],
        parentContact: [{required: true, message: '请选择上级联系人', trigger: 'change'}]
      },
      formData: {
        type: '1'
      },
      defaultData: {},
      parentList: [],
      schoolList: [],
      proList: [],
      bankList: [],
      cardList: [],
      academyList: [],
      formLoading: true,
      formDefaultRules: {},
      isDisabled: false,
      isShowForm: false,
      accountType: '',
      schoolName: ''
    }
  },
  created () {
    const _self = this;
    _self.formDefaultRules = FormItemRules;
    if (_self.query) {
      _self.fetchUserMsg();
    } else {
      _self.initOptionList()
      _self.formLoading = false
    }
  },
  methods: {
    handleBlur () {
      if (!this.formDefaultRules.isPHONE.test(this.formData.mobile)) {
        return new Error('输入的手机号不符合规则');
      } else {
        this.isShowForm = true
        this.fetch(`/sys/department/reviewUnitqueryByMobile/${this.formData.mobile}`).then(res => {
          if (res.data) {
            this.formData = res.data
            this.isDisabled = true
          } else {
            this.formData = {
              mobile: this.formData.mobile,
              type: '1'
            }
            this.isDisabled = false
          }
        })
      }
    },
    async initOptionList () {
      this.accountType = this.$store.state.role.accountType;
      this.schoolName = this.$store.state.user.schoolName;
      // if(accountType){
      // alert(this.$store.state.user.schoolName)
      // }
      this.fetchSchoolList(this.formData.type)
      this.fetchProList()
      this.fetchBankList()
      this.fetchCardList()
      this.fetchAcademyList()
    },
    async fetchSchoolList (type) {
      let param = {
        query: {
          type
        },
        page: {
          currPage: 1,
          pageSize: 10000
        }
      };
      let res = await this.post('/school/school/list', param)
      this.schoolList = res.data.list
    },
    changeLevel () {
      const _self = this;
      if (_self.formData.pointLevel === '1') {
        _self.formData.department = null;
        _self.formData.parentContact = null;
      }
    },
    fetchCardList () {
      let url = '/conf/confIdCardType/all'
      this.fetch(url).then(res => {
        this.cardList = res.data
      })
    },
    fetchAcademyList () {
      let url = '/school/schoolAcademy/getAllAcademyByUser'
      this.post(url).then(res => {
        this.academyList = res.data
      })
    },
    fetchProList () {
      let url = '/conf/confProvince/list'
      this.post(url).then(res => {
        this.proList = res.data
      })
    },
    fetchBankList () {
      let url = '/conf/confBank/list'
      this.post(url).then(res => {
        this.bankList = res.data
      })
    },
    fetchUserMsg () {
      const _self = this
      _self.fetch('/sys/user/info/' + _self.query).then(res => {
        _self.formData = res.data
        // _self.formData.idCardType = _self.formData.idCardTypeCode;
        _self.defaultData = JSON.parse(JSON.stringify(res.data))
        _self.initOptionList();
        _self.formLoading = false;
      });
    },
    // 确定回调事件
    dialogComfirm () {
      const _self = this;
      return new Promise((resolve, reject) => {
        _self.$refs['editUserForm'].validate((valid) => {
          if (valid) {
            let param = Object.compare(_self.defaultData, _self.formData);
            if (_self.defaultData.userId) {
              param.userId = _self.defaultData.userId
            }
            if (param.schoolId === '-1') {
              param.schoolId = ''
            }
            _self.post('/school/schoolDegreeOffice/saveOrUpdate', param).then(res => {
              resolve();
            }).catch(error => {
              reject(error);
            });
          } else {
            reject(new Error());
          }
        });
      });
    }
  }
}
</script>

<style lang='less'>
  .parentContact {
    .kh-form-item-label:before {
      margin-right: 2px
    }
  }

</style>



// WEBPACK FOOTER //
// src/layout/dialogs/systemManage/employerEdit2.vue